import { cn } from "@/lib/utils";

/** Compact unread count pill for sidebar nav items. */
export function NavBadge({ count }: { count: number }) {
  if (!count || count < 1) return null;
  return (
    <span
      className={cn(
        "ml-auto inline-flex min-w-5 shrink-0 items-center justify-center rounded-full",
        "bg-primary/15 px-1.5 text-[10px] font-semibold text-primary",
        "group-data-[collapsible=icon]:hidden"
      )}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
